var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLogin)?_c('div',{class:!_vm.isLogin && 'bg-color'},[_c('div',{staticClass:"Copyright-modal"},[_c('span',[_vm._v(_vm._s(_vm.copyright))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }